import { TournamentTypeAbstract } from "./TournamentTypeAbstract";

export class TournamentTypeShootout extends TournamentTypeAbstract {
}
